<template>
	<div class="guanli" v-if="showGuanli">
		<div class="con">
			<div class="shade" v-show='tc'>
				<div class="tc">
					<p><span>{{tit}}</span> <span class="closed" @click="closed"></span></p>
					<div style="padding-bottom: 35px;">
						<div class="iptbox">
							<span>部门:</span>
							<input v-model="change_department" type="text" />
						</div>
						<div class="iptbox">
							<span>角色:</span>
							<el-radio-group v-model="change_type">
								<el-radio label="负责人"></el-radio>
								<el-radio label="联系人"></el-radio>
							</el-radio-group>
						</div>
						<div class="iptbox">
							<span>姓名:</span>
							<input v-model="change_name" type="text" />
						</div>
						<div class="iptbox">
							<span>职务:</span>
							<input v-model="change_zhiwu" type="text" />
						</div>
						<div class="iptbox">
							<span>电话:</span>
							<input v-model="change_phone" type="text" />
						</div>

						<div class="iptbox">
							<span>Email:</span>
							<input v-model="change_email" type="text" />
						</div>
						<div class="iptbox">
							<span>手机:</span>
							<input v-model="change_mobile" type="text" />
						</div>

					</div>
					<div class="tc_bot">
						<button class="qx" @click="closed">取消</button>
						<button v-show="change" class="qd" @click="change_btn">确定</button>
						<button v-show="add" class="qd" @click="add_btn">确定</button>
					</div>
				</div>
			</div>

			<p class="con_tit"><span></span><strong>其他联系人管理</strong></p>
			<div class="con_con">
				<div style="width: 100%;border-bottom: 1px solid #D7D7D7;position: relative;">
					<span class="inline v_middle" style="height: 30px;line-height: 30px;font-size:16px;">其他联系人列表</span>
					<p class="note">此表为其他联系人列表，如需更改或完善会员对接部门负责人、联系人信息，请点击“重要信息变更”菜单进行编辑。</p>
					<button class="add_people" @click="add_people">+添加联系人</button>
				</div>
				<div class="form_tit">
					<span class="w1 fl clearfix">部门</span>
					<span class="w1 fl clearfix">角色</span>
					<span class="w1 fl clearfix">姓名</span>
					<span class="w1 fl clearfix">职务</span>
					<span class="w2 fl clearfix">电话</span>
					<span class="w4 fl clearfix">Email</span>
					<span class="w2 fl clearfix">手机</span>
					<span class="w3 fl clearfix">操作</span>
				</div>
				<ul class="list">
					<li v-for="(item,index) in data_arr" class="flex">
						<span class="w1 fl clearfix">{{item.department}}</span>
						<span class="w1 fl clearfix">{{item.role=='1'?'负责人':'联系人'}}</span>
						<span class="w1 fl clearfix">{{item.name}}</span>
						<span class="w1 fl clearfix">{{item.post}}</span>
						<span class="w2 fl clearfix">{{item.phone}}</span>
						<span class="w4 fl clearfix">{{item.email}}</span>
						<span class="w2 fl clearfix">{{item.mobile}}</span>
						<div class="w3 fl clearfix">
							<span @click="edito1(item.contacts_id,index)" class="fl clearfix w50 cur" style="color: #0076FF;">编辑</span>
							<span @click="delete1(item.contacts_id,index)" class="fr clearfix w50 cur" style="color: #D0021B;">删除</span>
						</div>
					</li>
				</ul>

			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	export default {
		data() {
			return {
				tit: '修改联系人',
				tc: false,
				change: false,
				add: false,
				id: '',
				data_arr: [],
				change_department: '',
				change_type: '',
				change_name: '',
				change_zhiwu: '',
				change_phone: '',
				change_email: '',
				change_mobile: '',
			};
		},
		props: {
			showGuanli: {
				type: Boolean
			}
		},
		created() {},
		mounted() {
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			var data1={
				'access-token':token
			};
			this.$axios({
				method: 'post',
				url: 'contact/showcontacters',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state == 2) {
					this.data_arr = response.data.result;
				}
			});

		},
		methods: {

			//增加联系人
			add_people() {
				this.tit = "添加联系人";
				this.tc = true;
				this.add = true;
				this.change_type = '';
				this.change_name = '';
				this.change_zhiwu = '';
				this.change_phone = '';
				this.change_email = '';
				this.change_mobile = '';
			},

			//编辑联系人
			edito1(e, index) {
				this.id = e;
				this.tit = "修改联系人";
				this.tc = true;
				this.change = true;
				this.change_department = this.data_arr[index].department;
				if(this.data_arr[index].role == 1) {
					var role = '负责人';
				} else {
					var role = '联系人';
				}
				this.change_type = role;
				this.change_name = this.data_arr[index].name;
				this.change_zhiwu = this.data_arr[index].post;
				this.change_phone = this.data_arr[index].phone;
				this.change_email = this.data_arr[index].email;
				this.change_mobile = this.data_arr[index].mobile;
			},
			//关闭弹窗
			closed() {
				this.tc = false;
				this.change = false;
				this.add = false;
			},
			//删除联系人
			delete1(e, index) {
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data = {
					'contacts_id': e,
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'contact/delete',
					data: Qs.stringify(data)
				}).then(response => {
					if(response.data.state == 3) {
						this.$toast(response.data.msg);
						this.data_arr.splice(index, 1);
					} else {
						this.$toast(response.data.msg);
					}
				});
			},
			//增加提交
			add_btn() {
				if(!this.change_department) {
					this.$toast('请输入部门');
					return false;
				};
				if(!this.change_type) {
					this.$toast('请选择角色');
					return false;
				};
				if(!this.change_name) {
					this.$toast('请输入姓名');
					return false;
				};
				if(!this.change_zhiwu) {
					this.$toast('请输入职务');
					return false;
				};
				if(!this.change_phone) {
					this.$toast('请输入电话');
					return false;
				};
				if(!this.change_email) {
					this.$toast('请输入Email');
					return false;
				};
				if(!this.change_mobile) {
					this.$toast('请输入手机');
					return false;
				};
				if(this.change_type == '负责人') {
					this.change_type = 1;
				} else {
					this.change_type = 2;
				};
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data = {
					'access-token':token,
					'contacts_id': this.id,
					'department': this.change_department,
					'role': this.change_type,
					'name': this.change_name,
					'post': this.change_zhiwu,
					'phone': this.change_phone,
					'email': this.change_email,
					'mobile': this.change_mobile,
				};
				this.$axios({
					method: 'post',
					url: 'contact/addcontact',
					data: Qs.stringify(data)
				}).then(response => {
					if(response.data.state == 6) {
						this.tc = false;
						this.change = false;
						this.add = false;
						var data1={
							'access-token':token
						};
						this.$axios({
							method: 'post',
							url: 'contact/showcontacters',
							data: Qs.stringify(data1)
						}).then(response => {
							if(response.data.state == 2) {
								this.$toast('添加成功');
								this.data_arr = response.data.result;
							}
						});
					} else {
						this.$toast(response.data.msg);
						if(this.change_type=='1'){
							this.change_type="负责人";
						}else if(this.change_type=='2'){
							this.change_type="联系人";
						}
					}

				});

			},
			//修改提交
			change_btn() {
				if(!this.change_department) {
					this.$toast('请输入部门');
					return false;
				};
				if(!this.change_type) {
					this.$toast('请选择角色');
					return false;
				};
				if(!this.change_name) {
					this.$toast('请输入姓名');
					return false;
				};
				if(!this.change_zhiwu) {
					this.$toast('请输入职务');
					return false;
				};
				if(!this.change_phone) {
					this.$toast('请输入电话');
					return false;
				};
				if(!this.change_email) {
					this.$toast('请输入Email');
					return false;
				};
				if(!this.change_mobile) {
					this.$toast('请输入手机');
					return false;
				};
				if(this.change_type == '负责人') {
					this.change_type = 1;
				} else {
					this.change_type = 2;
				};
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data = {
					'access-token':token,
					'contacts_id': this.id,
					'department': this.change_department,
					'role': this.change_type,
					'name': this.change_name,
					'post': this.change_zhiwu,
					'phone': this.change_phone,
					'email': this.change_email,
					'mobile': this.change_mobile,
				}
				this.$axios({
					method: 'post',
					url: 'contact/edit',
					data: Qs.stringify(data)
				}).then(response => {
					if(response.data.state == 5) {
						this.$toast(response.data.msg);
						this.tc = false;
						this.change = false;
						this.add = false;
						var data1={
							'access-token':token
						};
						this.$axios({
							method: 'post',
							url: 'contact/showcontacters',
							data: Qs.stringify(data1)
						}).then(response => {
							if(response.data.state == 2) {
								this.data_arr = response.data.result;
							}
						});
					} else {
						if(this.change_type == 1) {
							this.change_type = '负责人';
						} else if(this.change_type == 2){
							this.change_type = '联系人';
						}
						this.$toast(response.data.msg);						
					}

				});

			},
		}
	}
</script>
<style scoped>
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.inline {
		display: inline-block;
	}
	
	.v_middle {
		vertical-align: middle;
	}
	
	.w50 {
		width: 49%;
	}
	
	.cur {
		cursor: pointer;
	}
	
	.rap {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.shade {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
		background: rgba(0, 0, 0, .7);
	}
	
	.tc {
		width: 483px;
		height: auto;
		padding-bottom: 10px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
		border-radius: 4px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	
	.tc p {
		height: 55px;
		line-height: 55px;
		color: #000;
		font-size: 16px;
		font-weight: bold;
		padding: 0 15px;
		border-bottom: 1px solid #CFD4D6;
		margin-bottom: 24px;
	}
	
	.closed {
		float: right;
		margin-top: 22px;
		width: 11px;
		height: 11px;
		background: url(../../static/img/close.png) no-repeat;
		background-size: 100%;
	}
	
	.iptbox {
		line-height: 40px;
		height: 40px;
		padding: 0 15px;
		margin-bottom: 22px;
	}
	
	.iptbox span {
		width: 64px;
		height: 100%;
		display: inline-block;
		text-align: right;
		color: rgba(64, 64, 64, 1);
		margin-right: 20px;
	}
	
	.iptbox input {
		width: 355px;
		height: 40px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(195, 194, 194, 1);
		text-indent: 15px;
		box-sizing: border-box;
	}
	
	.tc_bot {
		padding: 10px 16px 0 0;
		width: 100%;
		height: 52px;
		border-top: 1px solid #CFD4D6;
		text-align: right;
		box-sizing: border-box;
	}
	
	.tc_bot button {
		display: inline-block;
		width: 65px;
		height: 32px;
		background: rgba(24, 144, 255, 1);
		border-radius: 4px;
		border: none;
		color: #fff;
	}
	
	.tc_bot .qx {
		border: 1px solid rgba(217, 217, 217, 1);
		background: rgba(255, 255, 255, 1);
		margin-right: 8px;
		color: rgba(0, 0, 0, 0.65);
	}
	
	.guanli {
		width: 100%;
		height: auto;
		background: #fff;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 100%;
		padding: 0 18px 18px;
		box-sizing: border-box;
		height: auto;
		position: relative;
		overflow: hidden;
	}
	
	.con_tit {
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	.con_con {
		width: 952px;
		height: 580px;
		border: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		padding: 32px 22px;
	}
	
	.note{
		color: red;
		width: 720px;
		padding-bottom: 5px;
	}
	
	.add_people {
		position: absolute;
		top: 0;
		right: 0;
		width: 140px;
		height: 40px;
		background: rgba(0, 118, 255, 1);
		border: none;
		color: #fff;
	}
	
	.form_tit {
		width: 100%;
		height: 40px;
		background: #D7D7D7;
		color: #404040;
		font-weight: bold;
		line-height: 40px;
		text-align: center;
	}
	
	.w1 {
		width: 85px;
	}
	
	.w2 {
		width: 110px;
	}
	
	.w3 {
		width: 148px;
	}
	
	.w4 {
		width: 160px;
	}
	
	.list {
		width: 100%;
		height: auto;
		border-top: 1px solid #EBEBEB;
		border-left: 1px solid #EBEBEB;
		border-right: 1px solid #EBEBEB;
		box-sizing: border-box;
	}
	
	.list li {		
		text-align: center;
		width: 100%;
		height: 40px;
		font-size: 13px;
		border-bottom: 1px solid #EBEBEB;
	}
</style>


// WEBPACK FOOTER //
// src/components/Guanli.vue